export default "__VITE_ASSET__CXxRPIbF__"